import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import LinearProgress from "@mui/material/LinearProgress";
import ListSubheader from "@mui/material/ListSubheader";
import Autocomplete from "@mui/material/Autocomplete";
import { InputBaseComponentProps } from "@mui/material";
import { SxProps } from "@mui/material/styles";
import { useGetAllPositionsQuery } from "entitites/employees/api/employeesApi";
import { Toast } from "shared";
import React from "react";

export const PositionSelectSearch = ({
  sx,
  error,
  helperText,
  inputProps,
  value,
  onChange,
}: {
  sx?: SxProps;
  error?: boolean;
  helperText?: string;
  inputProps?: InputBaseComponentProps;
  value?: number | string;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}) => {
  const {
    data: positions,
    isLoading,
    isError,
    isUninitialized,
    error: positionsError,
  } = useGetAllPositionsQuery();
  if (isLoading || isUninitialized) {
    return <LinearProgress sx={{ mt: -0.25, ml: -0.25 }} />;
  }

  if (isError) {
    return <Toast error={JSON.stringify(positionsError)} />;
  }

  return (
    <Autocomplete
      onChange={(event, newValue) =>
        onChange && onChange({ target: { value: newValue?.id } } as any)
      }
      // value={value}
      // error={error}
      // helperText={helperText}
      // inputValue={inputProps}
      fullWidth
      sx={{ width: 440, minWidth: 440 }}
      disablePortal
      options={positions
        .slice()
        .sort((a, b) => a.department.localeCompare(b.department))}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Поиск по позиции"
          error={error}
          helperText={helperText}
          size="small"
        />
      )}
      renderGroup={(params) => (
        <React.Fragment key={params.key}>
          {console.log(params)}
          <ListSubheader
            key={params.key}
            sx={{
              mt: 0,
              pt: 0,
              fontSize: 14,
              fontWeight: 600,
              bgcolor: "rgb(223 223 255)",
              color: "black",
            }}
          >
            {params.group}:
          </ListSubheader>
          {/* <ListSubheader
            key={params.key}
            sx={{
              fontSize: 13,
              bgcolor: "rgb(231 233 241)",
              color: "black",
            }}
          >
            {params.group.split("/")[1]}:
          </ListSubheader> */}
          {
            //@ts-ignore
            params?.children?.map((option, index) => (
              <MenuItem key={index} {...option.props} component="div">
                {option.key}
              </MenuItem>
            ))
          }
        </React.Fragment>
      )}
      renderOption={(props, option) => (
        <MenuItem {...props}>{option.name}</MenuItem>
      )}
      groupBy={(option) => `${option.department}`}
    />
  );
};
